import { type Theme } from '@hivebrite/design-system/Theme';

import getListColors from './getListColors';

const getPresetColors = ({
  type,
  theme,
  brandColors,
}: {
  brandColors?: Array<{ label: string; value: string }>;
  theme: Theme;
  type?: string;
}) =>
  getListColors({
    withTransparent: type === 'BackgroundColor',
    theme,
    brandColors,
  });

export default getPresetColors;
